module["exports"] = [
  "Apt. ###",
  "Zimmer ###",
  "# OG"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_AT/address/secondary_address.js
 ** module id = 236
 ** module chunks = 0
 **/